import { CorrespondentFeature } from "../api/graphql";
import { useCurrentUser } from "../SessionBoundary";

export default function useFeaturePermitted(feature: CorrespondentFeature) {
  const me = useCurrentUser();
  if (me.__typename !== "Visitor" && me.__typename !== "Inmate") return false;
  return me.correspondentFeatures.includes(feature);
}
